import React from 'react';
import Combobox from '@ls/react-combobox-grid';
import transactionCodes from 'state/selections/TransactionCodes'
import {txColumnDef} from 'state/selections/TransactionCodes'
import { useDispatch, useSelector } from 'react-redux';
import { setTransactionCodeFilter } from 'state/selections/actions';
import SelectionState from 'state/selections/SelectionState';

import {
  selectSelectedTransactionCodeFiltervalues
} from 'state/selections/selectors';

const TransactionCodeFilter = props => {
const dispatch = useDispatch();
const values = useSelector(
  selectSelectedTransactionCodeFiltervalues(SelectionState.UNCOMMITTED)
);

const options = transactionCodes.map(transcationCode  =>  ({transcationCode}));

const onChange = React.useCallback(
  
  transactionCodes => {
    dispatch(setTransactionCodeFilter(transactionCodes));
  },
  [dispatch]
);
return (
    <Combobox
      placeholder="Transaction Codes..."
      options={options}
      onChange={onChange}
      value={values}
      label={"Transaction Codes"}
     // loading={loading}
      valueKey="transcationCode"
      labelKey="transcationCode"
      columnDefs={txColumnDef}
      variation={1}
      multi
    />
  );
}

export default TransactionCodeFilter
